import { ReactNode } from 'react';
import '../../modal.css';

type Props = {
    safeAction?: () => void;
    safeText?: string;
    dangerAction?: () => void;
    dangerText?: string;
    dangerCss?: string;
    children: ReactNode;
};

const AppModal = ({
    safeAction,
    safeText,
    dangerAction,
    dangerText,
    dangerCss,
    children,
}: Props) => {
    return (
        <div className="modal-background">
            <div className="modal-content">
                {children}
                <div>
                    {dangerAction && (
                        <button
                            type="button"
                            onClick={dangerAction}
                            className={dangerCss}
                            style={{ float: 'right' }}
                        >
                            {dangerText}
                        </button>
                    )}
                    {safeAction && (
                        <button
                            type="button"
                            onClick={safeAction}
                        >
                            {safeText}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AppModal;
